export default __webpack_public_path__ + "static/media/screen7.f8548882.png";